const fieldSteps = {
  LAYER_HEIGHT_MIN: 0.05, // mm
  LAYER_HEIGHT_STEP: 0.0001, // mm
  EXTRUSION_WIDTH_STEP: 0.01, // mm
  RETRACT_STEP: 0.1, // mm
  SPEED_STEP: 0.1, // mm/s
};

export default fieldSteps;
